import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import store from "../../dependencies/redux/store";
import { I18nextProvider } from "react-i18next";
import i18n from "../../shared/i18n";
import Dashboard from "./components/Dashboard";

let persistor = persistStore(store);
const App = ({ pageProps }) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <I18nextProvider i18n={i18n}>
          <div>
            <Dashboard {...pageProps} />
          </div>
        </I18nextProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
